import React from 'react';
import Widget from "../../../../../components/prefabricated/Widget";
import Skeleton from "react-loading-skeleton";
import {Badge} from "reactstrap";

const SettingsPageLoadingSkeleton = (props)=>{
    return(
        <div className={"animated fadeIn animation-duration-7 "}>
            <div className="row">
                <div className={"col-12"}>
                    <Widget styleName={`p-0 bg-light`}>
                        <div className={"row"}>
                            <div className={"col-12 bb-font-fridge-bold text-center"}>
                                <h1 style={{fontSize: "40px"}}><Skeleton/></h1>
                            </div>
                        </div>
                        <Skeleton count={3}/>
                    </Widget>
                </div>

            </div>
            <div className="row">
                <div className={"col-8"}>
                    <div className="row">
                        <div className={"col-12"}>
                            <h1><Skeleton/></h1>
                            <Widget>
                                <h2 className={"text-center"}><Skeleton/></h2>
                                <Skeleton/>

                                <Skeleton count={3}/>
                            </Widget>

                            <hr/>
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-12"}>
                            <h1><Skeleton/></h1>
                            <Widget>
                                <h2 className={"text-center"}><Skeleton/></h2>
                                {/*<CardSubtitle><strong>Subscriber Since:</strong> {bbFormattedDateString(customer.CreatedDate, 'short')}</CardSubtitle>*/}
                                <Skeleton count={5}/>
                            </Widget>
                            <hr/>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <h1><Skeleton/></h1>
                            <p><Skeleton/></p>
                        </div>
                    </div>

                    <div className={"row"}>

                        <div className={"col-6"}>

                            <Widget>
                                <h3><Skeleton/></h3> <Badge color="grey"><Skeleton/></Badge>

                            </Widget>
                        </div>
                        <div className={"col-6"}>
                            <Widget>
                                <h3><Skeleton/></h3> <Badge color="grey"><Skeleton/></Badge>


                                <Skeleton count = {3}/>
                            </Widget>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-6"}>
                            <Widget>
                                <h3><Skeleton/></h3> <Badge color="grey"><Skeleton/></Badge>

                                <div>
                                    <Skeleton count={3}/>
                                </div>
                            </Widget>
                        </div>
                        <div className={"col-6"}>
                            <Widget>
                                <h3><Skeleton/></h3> <Badge color="grey"><Skeleton/></Badge>

                                <div>
                                    <Skeleton count={3}/>
                                </div>
                            </Widget>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <Widget>
                                <h3><Skeleton/></h3> <Badge color="grey"><Skeleton/></Badge>

                            </Widget>
                        </div>
                        <div className={"col-4"}>
                            <Widget>
                                <h3><Skeleton/></h3> <Badge color="grey"><Skeleton/></Badge>

                            </Widget>
                        </div>
                        <div className={"col-4"}>
                            <Widget>
                                <h3><Skeleton/></h3> <Badge color="grey"><Skeleton/></Badge>

                            </Widget>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-4"}>

                            <Widget>
                                <h3><Skeleton/></h3> <Badge color={"electric-blue-light"}><Skeleton/></Badge>
                            </Widget>
                        </div>

                    </div>
                    <hr/>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <p>
                                <em><Skeleton/></em>
                            </p>

                        </div>
                    </div>
                </div>

                <div className={"col-4"}>
                    <h2><Skeleton/></h2>
                    <p><Skeleton/></p>
                    <Skeleton count={2}/>
                    <hr/>
                    <h2><Skeleton/></h2>
                    <p><Skeleton/></p>
                    <Skeleton count={10}/>
                </div>
            </div>
            </div>
    )
}

export default SettingsPageLoadingSkeleton;